import {Redirect, Route} from 'react-router-dom';
import React from 'react';

export function capitalizeWords(text){
	return text.toLowerCase()
		.split(' ')
		.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
		.join(' ');
}

export function isFieldEmpty(str){
	return str.length === 0 ? true: false;
}

